export default "query countTotalErrorProne($tagIdList: [String]) {\n  countTotalErrorProne(tagIdList: $tagIdList) \n}";